module.exports = __webpack_public_path__ + "img/london.d9428296.jpg";